import { WidgetOptions } from '@sprinklr/stories/widget/WidgetOptions';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';

export type CountUpWidgetOptions = WidgetOptions;

export class CountUpWidgetOptionsImpl extends WidgetOptionsImpl implements CountUpWidgetOptions {}
